import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const data = {
  labels: ["Correos Leidos"],
  datasets: [
    {
      data: ["02", "03"],
      backgroundColor: ["#208020", "#BFBFBF"],
      hoverOffset: 0,
    },
  ],
};

const data2 = {
  labels: ["Ingresos a Digital Pension"],
  datasets: [
    {
      data: ["01", "02"],
      backgroundColor: ["#CEA622", "#BFBFBF"],
      hoverOffset: 0,
    },
  ],
};

const data3 = {
  labels: ["Correos Enviados"],
  datasets: [
    {
      label: "Correos",
      data: ["03"],
      hoverOffset: 0,
    },
  ],
};

const options = {
responsive: true,
  plugins: {
    legend: {
      display: true,
    },
    tooltip: {
      enabled: true,
    },
    doughnutLabel: {
      labels: [
        {
          render: "label",
          position: "outside",
          fontSize: 16,
          fontStyle: "bold",
          fontColor: "#000000",
        },
        {
          render: "percentage",
          fontColor: "#000000",
          fontSize: 16,
          fontStyle: "bold",
        },
      ],
    },
  },
};

const textCenter = {
  id: "textCenter",
  beforeDatasetsDraw(chart, args, pluginOpions) {
    const { ctx, data } = chart;

    ctx.save();
    ctx.font = "bold 25px sans-serif";
    ctx.fillStyle = "#252525";
    ctx.textAlign = "center";
    ctx.textBaseLine = "middle";
    ctx.fillText(
      data.datasets[0].data[0],
      chart.getDatasetMeta(0).data[0].x,
      chart.getDatasetMeta(0).data[0].y
    );
  },
};

function DonutChart() {
  return (
    <div className="container-fluid">
      <div className="d-flex flex-row">
        <Doughnut data={data3} options={options} plugins={[textCenter]} />
        <Doughnut data={data} options={options} plugins={[textCenter]} />
        <Doughnut data={data2} options={options} plugins={[textCenter]} />
      </div>
    </div>
  );
}

export default DonutChart;
